const digest = 'a0d702e93ad6c07c6a0a3f1cc8547dd3a7563dc21dd5d1d20d49f21e90d4fa74';
const css = `._popupDesktopWrapper_1g742_1{border-radius:.5rem;box-shadow:0 0 6px 0 #737373}._popupDesktopWrapper_1g742_1 ._popupDesktop_1g742_1{border-bottom:1px solid #e0e0e0;justify-content:flex-end}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'popupDesktopWrapper': '_popupDesktopWrapper_1g742_1', 'popupDesktop': '_popupDesktop_1g742_1' };
export const popupDesktopWrapper = '_popupDesktopWrapper_1g742_1';
export const popupDesktop = '_popupDesktop_1g742_1';
export { css, digest };